import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Typography,
} from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { CSidebar } from "@coreui/react";
import { storageService } from "Services/storage_service";
import { Icon } from "@mdi/react";
import Api from "api";
import logo from "Recursos/logo_genesis.png";
import { setSideBarShow } from "Slices/uiSlice";
import "./SideBar.scss";

const NewSideBar = () => {
  const user = storageService.getItem("user");
  const [menu, setMenu] = useState([]);
  const [openItems, setOpenItems] = useState({});
  const sidebarShow = useSelector((state) => state.ui.sidebarShow);
  const unfoldable = useSelector((state) => state.ui.sidebarUnfoldable);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!user) return;

    Api.getInstance()
      .executeQuery("api/ed/menu", { idRol: user.idRol, idSegmento: 1 })
      .then((resp) => {
        if (resp?.result) {
          setMenu(resp.data);
          if (resp.data.length === 1) {
            setOpenItems({ [resp.data[0].idOpcion]: true });
          }
        }
      })
      .catch(console.error);
  }, []);

  const handleToggle = (itemId) => {
    setOpenItems((prev) => ({
      [itemId]: !prev[itemId],
    }));
  };

  const getIcon = (iconName) => {
    try {
      return require(`materialdesign-js/icons/${iconName}`).default;
    } catch (error) {
      console.warn(`Icon not found: ${iconName}`);
      return null;
    }
  };

  return (
    <CSidebar
      position="fixed"
      unfoldable={unfoldable}
      visible={sidebarShow}
      className="sidebar"
      onVisibleChange={(visible) => {
        dispatch(setSideBarShow(visible));
      }}
    >
      <Box sx={{ height: "100vh", display: "flex", flexDirection: "column" }}>
        <Box className="sidebar-header">
          <img src={logo} className="sidebar-logo" alt="Genesis Logo" />
        </Box>
        <Box className="sidebar-content">
          <List>
            {menu?.map((mod) => {
              const hasChildren = mod.opciones?.length > 0;
              const isOpen = openItems[mod.idOpcion];
              const iconModule = getIcon(mod.icono);

              return (
                <React.Fragment key={mod.idOpcion}>
                  <ListItem disablePadding>
                    <ListItemButton
                      onClick={() => hasChildren && handleToggle(mod.idOpcion)}
                    >
                      <ListItemIcon>
                        {iconModule && <Icon path={iconModule} size={1} />}
                      </ListItemIcon>
                      <ListItemText primary={mod.nombre} />
                      {hasChildren &&
                        (isOpen ? (
                          <ExpandLess className="expand-icon" />
                        ) : (
                          <ExpandMore className="expand-icon" />
                        ))}
                    </ListItemButton>
                  </ListItem>

                  {hasChildren && (
                    <Collapse in={isOpen} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding>
                        {mod.opciones.map((opt) => (
                          <ListItem
                            key={opt.idOpcion}
                            disablePadding
                            className="child-menu-item"
                          >
                            <ListItemButton component={Link} to={opt.etiqueta}>
                              <ListItemText primary={opt.nombre} />
                            </ListItemButton>
                          </ListItem>
                        ))}
                      </List>
                    </Collapse>
                  )}
                </React.Fragment>
              );
            })}
          </List>

          {menu?.length === 0 && (
            <Box className="no-menu-message">
              <Typography variant="body2">
                No se han configurado opciones para este rol
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </CSidebar>
  );
};

export default React.memo(NewSideBar);
